<div class="container filter-bg" style="min-height: 1200px">
    <div class="row pt-2 mb-0">
        <div class="col-1 p-2 text-right cursor">
            <div class="input-group flex-nowrap" (click)="onBackClick()">
                <div class="input-group-prepend cursor border-0 outline-0 box-shadow-none  p-0 px-1">
                    <i class="fas fa-times font-size-18  cursor close text-white"></i>
                </div>
            </div>
        </div>

    </div>

    <div class="form-group row mt-1">
        <div class="col ">
            <ul class="btn-group btn-group-sm filter-tabs" role="group" aria-label="Filter options">
                <li class="btn btn-outline-secondary btn-light border-0 box-shadow-none filter-btn"
                    [ngClass]="{'btn-active': !this.FiltersList[0].collapsed, 'btn-outline-secondary btn-light':this.FiltersList[0].collapsed}"
                    (click)="onFilterOptionClick('DIETS',0)">Diets</li>
                <li class="btn btn-outline-secondary btn-light border-0 box-shadow-none filter-btn"
                    [ngClass]="{'btn-active': !this.FiltersList[1].collapsed, 'btn-outline-secondary btn-light':this.FiltersList[1].collapsed}"
                    (click)="onFilterOptionClick('CUISINES',1)">Cuisine</li>
                <li class="btn btn-outline-secondary btn-light border-0 box-shadow-none filter-btn"
                    [ngClass]="{'btn-active': !this.FiltersList[2].collapsed, 'btn-outline-secondary btn-light':this.FiltersList[2].collapsed}"
                    (click)="onFilterOptionClick('DISHES',2)">Dishes</li>
            </ul>
        </div>
        <div class="col mr-1 mt-1 pr-4 text-right">
            <button type="button" class="btn btn-sm border-0 box-shadow-none mt-0 filter-reset"
                (click)="onFilterOptionClick('RESET',0)">Reset</button>
        </div>

    </div>

    <div class="form-group row">
        <div class="col">
            <div class="row">
                <div class="col">
                    <i class="far fa-star text-white mr-1"></i>
                    <label for="olar1" class="pl-2 pt-1 text-white cursor ">OlarMe Recommended </label>
                </div>
                <div class="col-1 mt-1 mr-3 cursor">
                    <div class="round">
                        <input [checked]="olarmerecommended" name="olar1" type="checkbox" id="olar1"
                            (change)="onOlarClick($event,'1')" />
                        <label class="cursor" for="olar1"></label>
                    </div>
                </div>
                <div class="col-1"></div>
            </div>
            <div class="row">
                <div class="col">
                    <i class="far fa-handshake text-white"></i>
                    <label for="olar2" class="pl-2 pt-1 text-white cursor">Deals and Discounts</label>
                </div>
                <div class="col-1 mt-1 mr-3 cursor">
                    <div class="round">
                        <input [checked]="dealsanddiscount" name="olar2" type="checkbox" id="olar2"
                            (change)="onOlarClick($event,'2')" />
                        <label class="cursor" for="olar2"></label>
                    </div>
                </div>
                <div class="col-1"></div>
            </div>
            <div class="row">
                <div class="col">
                    <i class="fas fa-certificate text-white mr-1"></i>
                    <label for="olar3" class="pl-2 pt-1 text-white cursor">New Restaurants</label>
                </div>
                <div class="col-1 mt-1 mr-3 cursor">
                    <div class="round">
                        <input [checked]="newrestaurant" name="olar3" type="checkbox" id="olar3"
                            (change)="onOlarClick($event,'3')" />
                        <label class="cursor" for="olar3"></label>
                    </div>
                </div>
                <div class="col-1"></div>
            </div>
        </div>
    </div>

    <div class="row no-gutters form-group" *ngIf="FiltersList.length > 0">
        <div class="col">
            <div class="row cursor" *ngFor="let filter of FiltersList;let i=index;">
                <div class="col filter-tabs-bg">
                    <div class="row no-gutters" (click)="onFilterClick(filter,i,filter.collapsed)"
                        [attr.aria-expanded]="filter.collapsed" aria-controls="filter.name">
                        <div class="col">
                            <div class="row">
                                <div class="col">
                                    <label class="cursor" class="text-white fw-500 m-0 p-2" for="">
                                        {{filter.name}}
                                    </label>
                                </div>
                                <div class="col-1">
                                    <label class="m-0 float-right p-2 pt-08 pr-2 cursor">
                                        <i class="fas  float-right fa-chevron-down text-white" *ngIf="filter.collapsed"></i>
                                        <i class="fas fa-chevron-up float-right text-white" *ngIf="!filter.collapsed"></i>
                                    </label>
                                </div>
                                <div class="col-1"></div>
                            </div>
                        </div>
                    </div>

                    <div id="{{filter.name}}" [collapse]="filter.collapsed" [isAnimated]="true" class="container">
                        <div class="row pt-2" *ngFor="let option of filter.values;let j=index;">
                            <div class="col">
                                <div class="row">
                                    <div class="col">
                                        <img *ngIf="option.imgsource" width="20%" [defaultImage]="defaultImage" [lazyLoad]="option.imgsource" />
                                        <label for="{{option.optionName}}{{j}}"
                                            class="pl-2 pt-1 text-white cursor">{{option.optionName}}</label>
                                    </div>
                                    <div class="col-1 mt-1 mr-1 cursor">
                                        <div class="round">
                                            <input [checked]="option.optionSelected" name="{{option.optionName}}"
                                                type="checkbox" id="{{option.optionName}}{{j}}"
                                                (change)="onFilterOptionChecked($event,filter,option,i,j)" />
                                            <label class="cursor" for="{{option.optionName}}{{j}}"></label>
                                        </div>
                                    </div>
                                    <div class="col-1"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="row form-group">
        <div class="col">
            <br />
            <br />
            <br />
        </div>
    </div>

</div>
<div class="footer-cart m-0">
    <div class="row form-group m-0 mx-1 mb-0 py-2 filter-bg">

        <div class="col">
            <button type="button" (click)="onApplyClick()" style="width: 100%"
                    class="btn box-shadow-none float-right filter-reset">
                Apply
            </button>
        </div>

    </div>
</div>
<app-loading-component></app-loading-component>